import React from "react";
import { Link } from "react-router-dom";
import Text from "./Text";
import rateStar from "../assets/images/ratestar.svg";
import styled from "styled-components";

const CoachCard = ({ coachImage }) => {
  return (
    <HoveredCard className="card inline-block pb-5 mt-12 transition-transform duration-500">
      <Link to="influencers/someId">
        <div className="img">
          <img
            src={coachImage}
            alt=""
            className="inline-block align-baseline"
          />
        </div>
        <div className="body flex flex-col items-center">
          <div className="status inline-block mb-3">
            <Text
              text={"Available"}
              component="p"
              classes={
                "rounded-full text-white bg-[#79b872] p-1 text-[11px] font-semibold"
              }
            />
          </div>
          <div className="name text-center">
            <Text text={"Kubra Ozturk"} classes="text-white" component={"h5"} />
          </div>
          <div className="rate">
            <div className="stars flex flex-row justify-center">
              <img src={rateStar} alt="" className="h-4 w-4" />
              <img src={rateStar} alt="" className="h-4 w-4" />
              <img src={rateStar} alt="" className="h-4 w-4" />
              <img src={rateStar} alt="" className="h-4 w-4" />
              <img src={rateStar} alt="" className="h-4 w-4" />
            </div>
          </div>
          <div className="time flex text-sm text-[#828282] font-light">
            <Text text={"30 min"} classes="pl-1" />
            <Text text={"|"} classes="pl-1" />
            <Text text={"Istanbul time"} classes="pl-1" />
          </div>
          <div className="languages text-[11px] my-2">
            <ul className="flex flex-row justify-between">
              <li className="mr-3">
                <Text
                  text={"English"}
                  classes="text-[#a0a0a0] hover:text-white hover:bg-[#a0a0a0] border px-3 py-2 transition-all duration-200"
                />
              </li>
              <li className="pr-2">
                <Text
                  text={"Turkish"}
                  classes="text-[#a0a0a0] hover:text-white hover:bg-[#a0a0a0] border px-3 py-2 transition-all duration-200"
                />
              </li>
              <li className="pr-2">
                <Text
                  text={"English"}
                  classes="text-[#a0a0a0] hover:text-white hover:bg-[#a0a0a0] border px-3 py-2 transition-all duration-200"
                />
              </li>
            </ul>
          </div>
          <div className="price text-[#e66553] text-sm">
            <Text text={"899 TL/Monthly"} />
          </div>
        </div>
      </Link>
    </HoveredCard>
  );
};

const HoveredCard = styled.div`
  &:hover {
    transform: translateY(-4px);
  }
`;

export default CoachCard;
